import { createBlock } from 'factories/block';
import { createEditableBtn } from './editableBtn';

// defaults to true
// useBackgroundControls: useBackgroundControls !== undefined ? useBackgroundControls : true,

export type MediaBlock = {
  child?: number;
  src?: string;
  audioSrc?: string;
  name?: string;
  style?: { [key: string]: number | string };
  removeTypes?: string[];
  forceInclude?: string[];
  useBackgroundControls?: boolean;
  bulletColor?: string;
  fit?: string;
  imgPlaceholderIndex?: number;
  isAdditionalMedia?: boolean;
  type?: string;
  textPlaceholderContent?: string;
  className?: string;
};

const createTranscriptBlock = useBackgroundControls => {
  return createBlock(
    'Transcript',
    [
      createBlock('Text', [], {
        props: {
          useBackgroundControls:
            useBackgroundControls !== undefined ? useBackgroundControls : true,
        },
      }),
      createEditableBtn({ label: 'Continue' }),
    ],
    {}
  );
};

export const createMediaBlock = (props: MediaBlock) => {
  const {
    child = 1,
    src = undefined,
    audioSrc = undefined,
    removeTypes = [],
    forceInclude = [],
    useBackgroundControls,
    bulletColor,
    fit,
    imgPlaceholderIndex,
    isAdditionalMedia,
    textPlaceholderContent,
    className,
  } = props;

  // if is an image
  // image specific props;

  return createBlock(
    'Media',
    [
      createBlock('Text', [], {
        props: {
          useBackgroundControls:
            useBackgroundControls !== undefined ? useBackgroundControls : true,
          bulletColor,
          ...(textPlaceholderContent && {
            content: textPlaceholderContent,
          }),
          className,
        },
      }),

      createBlock('Image', [], {
        props: {
          src: child === 1 && src ? src : undefined,
          fit,
        },
      }),

      createBlock('Video', [createTranscriptBlock(useBackgroundControls)], {
        props: {
          src: child === 2 && src ? src : 'https://vimeo.com/744068341',
        },
      }),
      createBlock('SVG', [], {
        props: {
          src: child === 3 && src,
        },
      }),
      createBlock('Embed', [], {
        props: {
          src: child === 4 && src,
        },
      }),
      createBlock('Audio', [createTranscriptBlock(useBackgroundControls)], {
        props: {},
      }),
      createBlock(
        'PDF',
        [
          createBlock(
            'OpenPDF',
            [
              createBlock('Text', [], {
                props: {
                  content: 'Example description text',
                },
              }),
            ],
            {
              props: {
                // src: pdf_default,
                fit: 'cover',
              },
            }
          ),
        ],
        {
          props: {
            src: child === 6 && src ? src : '',
            displayInline: false,
          },
        }
      ),
    ],
    {
      props: {
        name: props.name || '',
        style: props.style || {},
        child,
        removeTypes,
        forceInclude,
        src,
        imgPlaceholderIndex,
        isAdditionalMedia,
      },
      meta: {
        subType: 'Media',
      },
    }
  );
};
